
export const OPEN_MODAL = "modalDeleteLastProduct/OPEN_MODAL";
export const CLOSE_MODAL = "modalDeleteLastProduct/CLOSE_MODAL";
